import { z } from "zod"

export const SHOPIFY_METAFIELD_MAX_LENGTH = 256

export const ShopifyMetafieldEntrySchema = z.object({
  key: z.string().min(1).max(SHOPIFY_METAFIELD_MAX_LENGTH),
  description: z.string().min(1).max(SHOPIFY_METAFIELD_MAX_LENGTH),
})

export const ShopifyMetafieldOwnerTypeEnum = z.enum(["product", "productVariant", "order"])
export type ShopifyMetafieldOwnerType = z.infer<typeof ShopifyMetafieldOwnerTypeEnum>

export const ShopifyMetafieldsConfigSchema = z.object({
  product: z.array(ShopifyMetafieldEntrySchema).default([]),
  productVariant: z.array(ShopifyMetafieldEntrySchema).default([]),
  order: z.array(ShopifyMetafieldEntrySchema).default([]),
  productTags: z.array(ShopifyMetafieldEntrySchema).default([]),
  orderTags: z.array(ShopifyMetafieldEntrySchema).default([]),
  lineItemProperty: z.array(ShopifyMetafieldEntrySchema).default([]),
})

export const ShopifyMetafieldDefinitionSchema = z.object({
  key: z.string(),
  name: z.string(),
  description: z.string(),
  type: z.string(),
})
export const ShopifyMetafieldDefinitionsResponseDataSchema = z.array(
  ShopifyMetafieldDefinitionSchema,
)

export type ShopifyMetafieldEntry = z.infer<typeof ShopifyMetafieldEntrySchema>
export type ShopifyMetafieldsConfig = z.infer<typeof ShopifyMetafieldsConfigSchema>
